import { useEffect } from 'react'
import { SelectOptions } from '../types'

export const useDisabledWhenNotSelectedMethodoly = ({
    selectedMethodology,
    setEnableRigFloor,
    setIsActButtonDisabled
}: {
    selectedMethodology: SelectOptions | undefined
    setEnableRigFloor: (value: boolean) => void
    setIsActButtonDisabled?: (value: boolean) => void
}): void => {
    useEffect(() => {
        if (!selectedMethodology && typeof setIsActButtonDisabled === 'function') {
            setEnableRigFloor(false)
            setIsActButtonDisabled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMethodology, setIsActButtonDisabled])
}
